// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizSocialShareBtn_cont__2x-jM","label":"BizSocialShareBtn_label__3lJr-","img":"BizSocialShareBtn_img__207SX"};